import { GenerateCertRequestPayload } from './Certificate.types'
import { dispatcherActionType } from '../../../core/utils/interfaces'
import { actionErrorNotifier } from '../../../core/utils/helpers'
import { actionCoreApi } from '../../../core/utils/api'
import HTTPUrlHelper from '../../../shared/helpers/HTTPUrlHelper'

export const fetchCertificate = (
  payload: GenerateCertRequestPayload,
  id: string,
  type: string
): dispatcherActionType =>
  actionErrorNotifier(
    actionCoreApi(
      'GENERATE_CLIENT_AUTH_CERT',
      type === 'standard'
        ? HTTPUrlHelper.generateClientAuthCertAPI(id)
        : HTTPUrlHelper.generateClientAuthCertServiceUserAPI(id),
      'POST',
      payload
    )
  )
